import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-founder-home',
  templateUrl: './founder-home.component.html',
  styleUrls: ['./founder-home.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule]
})
export class FounderHomeComponent implements OnInit {

  constructor(){}

  ngOnInit(): void {
    
  }

  gotolink(val:any) {
    window.open(val, '_blank')

  }

}
